export default {
  contractScheduledRateChanges: state => state.contractScheduledRateChanges
}
